import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AuthViewController from "../redux/actions/AuthViewController";
import AuthLayout from "../components/auth/AuthLayout";
import { BRAND } from "../components/auth/authTheme";

const ActivationSuccessPage = () => {
  const { activeAccount } = AuthViewController();
  const { uid, token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (uid && token) {
      dispatch(activeAccount({ uid, token }));
    }
  }, [dispatch, uid, token]);

  return (
    <AuthLayout title="Account activated!" showFooter={false}>
      <Box sx={{ textAlign: "center", py: 1 }}>
        <CheckCircleOutlineIcon
          sx={{ fontSize: 64, color: BRAND.success, mb: 2 }}
        />

        <Typography
          variant="body1"
          sx={{ color: BRAND.text, mb: 3, lineHeight: 1.7 }}
        >
          Your account has been activated. Please check your email for the{" "}
          <strong>reset password</strong> and <strong>onboarding link</strong>.
          Complete this before logging in.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          disableElevation
          onClick={() => navigate("/login")}
          sx={{
            bgcolor: BRAND.success,
            color: "#fff",
            py: 1.5,
            borderRadius: "10px",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { bgcolor: BRAND.successHover },
          }}
        >
          Go to sign in
        </Button>
      </Box>
    </AuthLayout>
  );
};

export default ActivationSuccessPage;
